import apiSlice from "./apiSlice";
const clearancePackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllClearance: builder.query({
      query: (req) => ({
        url: `clearance`,
        params: req,
      }),
      keepUnusedDataFor: 1,
    }),
    getClearancePackages: builder.query({
      query: ({ projectId, type }) => {
        const params = new URLSearchParams();
        if (projectId) params.append("projectId", projectId);
        if (type) params.append("type", type);
        return `WBS?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetClearancePackagesQuery,
  useLazyGetClearancePackagesQuery,
  useGetAllClearanceQuery,
} = clearancePackagesSlice;
